import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LicenseMetrics from '../licenseMetrics';
import TimelineComponent from '../graphComponents/timelineComponent';
import RankingComponent from '../graphComponents/rankingComponent';
import ROIComponent from '../graphComponents/ROIComponent';
import BenchMarkingComponent from '../graphComponents/benchMarkingComponent';
import '../licenseAnalyticsPage/FinancePageLayout.css';
import {
  getTotalStaff,
  getStaffCost,
  getStaffQualifiedCoaches,
  getYOYTotalStaff,
  getYOYStaffCost,
  getYOYQualifiedCoaches,
  getClubValue,
} from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { shortenNumber } from '../licenseAnalyticsSupport/calculationsUtils';
import { useTranslation } from 'react-i18next';
import { PAGE } from '../licenseAnalyticsSupport/typeInterfaces';
import { getClubDepartments } from '../../../api/club';
import { setDepartmentsResponse } from '../../../redux/reducers/licenceAnalytics';

const StaffLayoutPage = React.memo(() => {
  const totalStaff = useSelector(getTotalStaff);
  const staffCost = useSelector(getStaffCost);
  const qualifiedCoachCount = useSelector(getStaffQualifiedCoaches);
  const getYOYValue = useSelector(getYOYTotalStaff);
  const getYOYValue2 = useSelector(getYOYStaffCost);
  const getYOYValue3 = useSelector(getYOYQualifiedCoaches);
  const [t] = useTranslation();
  const club = useSelector(getClubValue);
  const prefix = club ? t('DC_5_CLUB') : t('AVERAGE');

  const dispatch = useDispatch();
  const [departments, setDepartments] = useState([]);
  const clubFilter = useSelector(getClubValue);
  const activeClubId = useSelector((state:any) => state?.clubDetails?.id);
  useEffect(() => {
    const fetchDepartments = async () => {
      const response = await getClubDepartments({
        clubId: clubFilter?.id || activeClubId,
        isExport: clubFilter?.id == null && activeClubId == null,
      });
      return response;
    };

    fetchDepartments().then(res => {
      const tempArr: any = res.map((d:any) => {
        return { id: d.id, label: d.name };
      });
      setDepartments(tempArr);
      dispatch(setDepartmentsResponse(tempArr));
    });
  }, [clubFilter, activeClubId]);

  return (
    <div className="container">
      <div className="a commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('TOTAL_STAFF')}
          spendValue={totalStaff || '-'}
          metricsValue={getYOYValue}
          showYOY
        />
      </div>
      <div className="b commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('STAFF_COSTS')}
          spendValue={shortenNumber(staffCost) || '-'}
          metricsValue={getYOYValue2}
          showYOY
          showYen
        />
      </div>
      <div className="c commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('QUALIFIED_COACHES')}
          spendValue={qualifiedCoachCount || '-'}
          metricsValue={getYOYValue3}
          showYOY
        />
      </div>

      <div className="d commonBox">
        <TimelineComponent page={PAGE.STAFF} departments={departments}/>
        {/* <RankingComponent page={PAGE.STAFF} /> */}
        <RankingComponent />
      </div>
      <div className="e commonBox">
        <ROIComponent page={PAGE.STAFF} departments={departments}/>
      </div>
      <div className="f commonBox">
        <BenchMarkingComponent page={PAGE.STAFF} departments={departments}/>
      </div>
    </div>
  );
});

export default StaffLayoutPage;
